import { apiFetch } from "@/shared/api/http";

export interface AppReward {
  resgateId: string;
  recompensaId: string;
  titulo: string;
  descricao?: string | null;
  tipo: "Simbolica" | "Material" | "Beneficio" | string;
  badge?: string | null;
  status: "Pendente" | "Entregue" | string;
  disponibilizadaEmUtc: string;
  entregueEmUtc?: string | null;
  observacao?: string | null;
}

export function getMyGamificationRewards() {
  return apiFetch<AppReward[]>("/api/app/gamificacao/recompensas/minhas");
}
